import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { NoInfer } from "react-redux";
import {
  MemberAwardVipType,
  MemberStateType,
  MemberVipResponseType,
} from "types/memberVip";

import { getMemberAward, getMemberVip } from "./member.thunk";

export const extraReducers = (
  builder: ActionReducerMapBuilder<NoInfer<MemberStateType>>,
) => {
  builder
    .addCase(getMemberVip.pending, (state: MemberStateType) => {
      state.isLoading = true;
    })
    .addCase(
      getMemberVip.fulfilled,
      (
        state: MemberStateType,
        action: PayloadAction<MemberVipResponseType>,
      ) => {
        state.isLoading = false;
        state.dataMemberVip.data = { ...action.payload.data };
      },
    );

  builder
    .addCase(getMemberAward.pending, (state: MemberStateType) => {
      state.dataAwardVip.isLoadingAward = true;
    })
    .addCase(
      getMemberAward.fulfilled,
      (state: MemberStateType, action: PayloadAction<MemberAwardVipType>) => {
        state.dataAwardVip.isLoadingAward = false;
        state.dataAwardVip.data = action.payload.data;
      },
    );
};
